<div class="grid col-12 justify-content-evenly">
  <div class="col-12 sm:col-6 lg:col-12 xl:col-3 p-2">
    Select a location
    <p-dropdown [options]="locations" [(ngModel)]="selectedLocation" optionLabel="name" (onChange)="onLocationChange()">
      <ng-template pTemplate="selectedItem">
        @if (selectedLocation) {
        <div class="flex align-items-center gap-2">
          <div>{{ selectedLocation.Desc }}</div>
        </div>
        }
      </ng-template>
      <ng-template let-location pTemplate="item">
        <div class="flex align-items-center gap-2">
          <div>{{ location.Desc }}</div>
        </div>
      </ng-template>
    </p-dropdown>
  </div>
</div>
<div class="grid col-12 justify-content-evenly">
  @for (group of groups; track group.Id) {
  <div class="col-12 sm:col-6 lg:col-12 xl:col-3 p-2">
    <a class="no-underline" [routerLink]="[group.Id]" (click)="onGroupClick(group)">
      <div class="p-4 border-1 surface-border surface-card border-round pointer">
        <div class="flex flex-column align-items-center gap-3 py-5">
          <img class="w-9 shadow-2 border-round" [src]="group.Topic | stationImage" [alt]="group.Description" />
          <div class="text-2xl font-bold">{{group.Description}}</div>
        </div>
      </div>
    </a>
  </div>
  }
  @empty {
  <div class="col-12 sm:col-6 lg:col-12 xl:col-3 p-2">No station groups found.</div>
  }
</div>
@if (isLoading()) {
<div class="progress-spinner">
  <p-progressSpinner></p-progressSpinner>
</div>
}